import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation DeleteChannel($id: ID!) {
  deleteChannel(id: $id) {
    id
  }
}`;

function deleteChannel(id) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
    },
  }).then((res) => res.data.deleteChannel);
}

export default deleteChannel;
